import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { PlusCircle } from "../../../../../assets/svgIcons";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { WalletDetailsForm } from "./WalletDetailsForm";
import secondaryComponents from "../../..";
import { formatCurrency } from "../../../../../helpers";
import primaryComponents from "../../../../primaryComponents";
import { useCheckoutHelper } from "../../../../../hooks/useCheckoutHelper";

export const StoreWalletPayment = () => {
  const [isActive, setIsActive] = useState(false);
  const { payment, customer, store_wallet, setStoreWallet } =
    useCheckoutHelper();

  useEffect(() => {
    setStoreWallet(null);
  }, []);

  return (
    <>
      <section>
        <h5>Store Wallet Payment</h5>

        <div className={`${globalStyles.cardWithBorder}`}>
          <div className="w-100 mb-2 d-flex justify-content-between align-items-center">
            <span
              className={`smallest-text-size gray--text ${styles.textBackground}`}
            >
              Wallet Details
            </span>

            <primaryComponents.Button
              onClick={() => setIsActive(true)}
              classNames={"btn btn--outline"}
              style={{
                height: "40px",
                borderRadius: "20px",
                fontSize: "14px",
                padding: "0 15px",
              }}
            >
              <span className="mr-2">Select Wallet</span> <PlusCircle />
            </primaryComponents.Button>
          </div>
          <p className="smallext-text-size">
            {store_wallet ? (
              <>
                <span className="d-flex">
                  <span className="dark--text font-weight-semibold">
                    {formatCurrency({
                      value: store_wallet?.balance,
                      currencyCode: store_wallet?.currency_code,
                    })}
                  </span>
                  <span className="mx-1">-</span>
                  <span className="dark--text font-weight-semibold mr-4">
                    <span className="gray--text">
                      {customer?.customerName}
                      <span className="orange--text">
                        {" "}
                        ({store_wallet?.tag})
                      </span>
                    </span>
                  </span>
                </span>
              </>
            ) : (
              "No wallet selected"
            )}
          </p>
        </div>
      </section>

      <secondaryComponents.Modal
        width={550}
        isActive={isActive}
        closeModal={() => {
          if (store_wallet && store_wallet?.session_id)
            return setIsActive(false);

          setStoreWallet(null);
          setIsActive(false);
        }}
      >
        <WalletDetailsForm
          setStoreWallet={setStoreWallet}
          closeModal={() => setIsActive(false)}
          amount={payment?.pay_with_store_wallet?.amount}
        />
      </secondaryComponents.Modal>
    </>
  );
};
